// extracted by mini-css-extract-plugin
export var circle = "_c1-1";
export var exitConfirmationModal = "_c1-5";
export var iframe = "_c1-0";
export var offline = "_c1-3";
export var online = "_c1-2";
export var workstationSelectError = "_c1-4";